var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"ml-4 mt-2 mb-4 white--text",attrs:{"depressed":"","rounded":"","color":"red lighten-1"},on:{"click":_vm.cancelarSub}},[_vm._v("cancelar suscripción")])
}
var staticRenderFns = []

export { render, staticRenderFns }